import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getIcon } from '../lib/icons';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/categories`)
      .then(r => r.json())
      .then(data => setCategories(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  return (
    <div>
      <div style={{ padding: '24px 20px 12px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 800, color: 'var(--text-dark)', marginBottom: '4px' }}
            data-testid="categories-title">
          Categories Juridiques
        </h1>
        <p style={{ fontSize: '14px', color: 'var(--text-gray)' }}>
          Explorez les textes de loi par domaine
        </p>
      </div>
      <div className="page-container">
        <div className="category-grid">
          {categories.map(cat => {
            const Icon = getIcon(cat.icon);
            return (
              <Link
                key={cat.id}
                to={`/categorie/${cat.id}`}
                className="category-card"
                data-testid={`cat-${cat.id}`}
              >
                <div className="icon-circle">
                  <Icon />
                </div>
                <div className="category-name">{cat.name}</div>
                <div className="category-count">{cat.total_texts} texte{cat.total_texts !== 1 ? 's' : ''}</div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoriesPage;
